function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgClosePopup = function SvgClosePopup(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 10 10",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#0A3847",
    fillRule: "nonzero",
    d: "M4.664 5.68 2.058 8.294c-.301.302-.762.33-1.03.06-.268-.268-.24-.731.06-1.034l2.607-2.615-2.606-2.615c-.302-.303-.33-.766-.061-1.034.268-.27.729-.242 1.03.06l2.606 2.616L7.27 1.118c.302-.303.763-.33 1.03-.061.269.268.241.731-.06 1.034L5.634 4.706 8.24 7.321c.301.303.329.766.06 1.035-.267.268-.728.241-1.03-.061z",
    style: {
      mixBlendMode: "normal"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClosePopup);
export default ForwardRef;